const HARD_SENTENCE_ENDINGS = new Set(['。', '！', '？', '؟', '۔', '।']);
const SPACED_SENTENCE_ENDINGS = new Set(['.', '!', '?']);

function compactWhitespace(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

export function splitJourneyExplanationText(value) {
  const text = compactWhitespace(value);
  if (!text) return [];

  const parts = [];
  let start = 0;

  for (let index = 0; index < text.length; index += 1) {
    const character = text[index];
    const nextCharacter = text[index + 1];
    const hardEnding = HARD_SENTENCE_ENDINGS.has(character);
    const spacedEnding = SPACED_SENTENCE_ENDINGS.has(character)
      && (index === text.length - 1 || /\s/.test(nextCharacter || ''));

    if (!hardEnding && !spacedEnding) continue;

    const sentence = text.slice(start, index + 1).trim();
    if (sentence) parts.push(sentence);
    start = index + 1;
  }

  const remainder = text.slice(start).trim();
  if (remainder) parts.push(remainder);

  return parts.length ? parts : [text];
}

export function joinJourneyExplanationText(parts = []) {
  return compactWhitespace(parts.filter(Boolean).join(' '));
}
